import { render, staticRenderFns } from "./lebals.vue?vue&type=template&id=4f5dd3f0&scoped=true&"
import script from "./lebals.vue?vue&type=script&lang=js&"
export * from "./lebals.vue?vue&type=script&lang=js&"
import style0 from "./lebals.vue?vue&type=style&index=0&id=4f5dd3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dd3f0",
  null
  
)

export default component.exports